import { call, select } from 'redux-saga/effects';
import { User } from 'features/users/types';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { selectE2eeEnabled } from 'features/e2ee/e2eeSlice';
import { eventBus } from 'utils/eventBus';

export function* sendWaitingUsersJoinedSaga(users: User[]) {
  const canControlRoomEntry: boolean = yield call(
    hasPermissionsSaga,
    PermissionTypes.controlRoomEntry
  );

  if (!canControlRoomEntry) {
    return;
  }

  const e2eeEnabled: boolean = yield select(selectE2eeEnabled);
  const readyUsers = e2eeEnabled ? users.filter((user) => Boolean(user.name)) : users;

  if (readyUsers.length > 0) {
    yield call(eventBus.sendMessage, 'waitingUsersJoined', undefined, { users: readyUsers });
  }
}
